var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8221 13.5475L6.80714 13.5622V13.5832V15.1079H1.71429C0.789797 15.1079 0.05 14.3717 0.05 13.4737V1.68421C0.05 0.777919 0.789633 0.05 1.71429 0.05H10.2653L15.3786 5.0736V5.84972C14.8631 5.90829 14.3888 6.11352 14.0135 6.48223L12.9481 7.52895H7.76429V1.68421V1.63421H7.71429H1.71429H1.66429V1.68421V13.4737V13.5237H1.71429H6.84633L6.8221 13.5475ZM9.46361 1.22749L9.37857 1.14394V1.26316V5.89474V5.94474H9.42857H14.1429H14.2651L14.1779 5.85907L9.46361 1.22749ZM16.9802 9.38659L16.9792 9.38749L16.1743 10.1783L14.4971 8.53053L15.3008 7.74093L15.3008 7.74094L15.3017 7.74002C15.4444 7.59243 15.6953 7.59111 15.8478 7.74093L16.9792 8.85251C17.1313 9.00185 17.1299 9.24686 16.9802 9.38661L16.9802 9.38659ZM13.8257 9.19009L15.5029 10.8379L10.2995 15.95H8.62143V14.3031L13.8257 9.19009Z",
    fill: "#5B88BA",
    stroke: "white",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditComment);
export default __webpack_public_path__ + "static/media/edit_comment.8653dd8cc7360a8cc5872f8168c45135.svg";
export { ForwardRef as ReactComponent };